module.exports = __webpack_public_path__ + "static/media/duolingo.e9ebed4a.svg";